export default "<div class=\"loaderWrap\">\n    <mat-spinner></mat-spinner>\n</div>\n"